 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		11: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		11: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"438238ce735cb86152492855ee3f160ec420997f","2":"34692a9b614e75619b8e184bddb0b3c2ff3513c3","3":"ee949b2b07ca884f0b22538b9f496ad97bbc8c20","4":"56044c602de0e43a2cd4294be05cb9c30a8532fc","5":"73f3f4c2","6":"a089a8acdb26dadc66876f444bca0ebddd606de4","7":"component---src-pages-home-index-js","8":"d487e1d7","9":"f39abd17","10":"component---ambassador-docs-docs-1-12-js-doc-page-js","12":"61af03ec","14":"component---ambassador-docs-docs-1-10-js-doc-page-js","15":"component---ambassador-docs-docs-1-11-js-doc-page-js","16":"component---ambassador-docs-docs-1-3-js-doc-page-js","17":"component---ambassador-docs-docs-1-4-js-doc-page-js","18":"component---ambassador-docs-docs-1-5-js-doc-page-js","19":"component---ambassador-docs-docs-1-6-js-doc-page-js","20":"component---ambassador-docs-docs-1-7-js-doc-page-js","21":"component---ambassador-docs-docs-1-8-js-doc-page-js","22":"component---ambassador-docs-docs-1-9-js-doc-page-js","23":"component---ambassador-docs-docs-pre-release-js-doc-page-js","24":"component---src-pages-404-js","25":"component---src-pages-about-us-events-js","26":"component---src-pages-about-us-news-js","27":"component---src-pages-best-practices-index-js","28":"component---src-pages-cloud-acceleration-pyramid-index-js","29":"component---src-pages-codenewbie-index-js","30":"component---src-pages-codenewbiecloud-index-js","31":"component---src-pages-contact-index-js","32":"component---src-pages-demo-index-js","33":"component---src-pages-devdiscuss-index-js","34":"component---src-pages-docs-index-js","35":"component---src-pages-edge-stack-editions-index-js","36":"component---src-pages-edge-stack-faq-js","37":"component---src-pages-editions-index-js","38":"component---src-pages-eula-js","39":"component---src-pages-learn-kubernetes-glossary-index-js","40":"component---src-pages-partners-index-js","41":"component---src-pages-preview-events-js","42":"component---src-pages-preview-index-js","43":"component---src-pages-preview-news-js","44":"component---src-pages-preview-partners-js","45":"component---src-pages-products-argo-index-js","46":"component---src-pages-products-index-js","47":"component---src-pages-resources-index-js","48":"component---src-pages-terms-of-service-js","49":"component---src-pages-use-case-collaborative-development-index-js","50":"component---src-pages-use-case-local-kubernetes-development-index-js","51":"component---src-pages-use-cases-kubernetes-api-gateway-index-js","52":"component---src-templates-features-page-js","53":"component---src-templates-glossary-page-js","54":"component---src-templates-home-home-template-js","55":"component---src-templates-internal-news-page-js","56":"component---src-templates-old-resource-page-js","57":"component---src-templates-person-page-js","58":"component---src-templates-regular-page-js","59":"component---src-templates-resource-page-js","60":"component---src-templates-tutorial-page-js","61":"component---src-templates-webinar-page-js","62":"component---src-templates-white-paper-page-js"}[chunkId]||chunkId) + "-" + {"0":"89fd2ae28bdf06750a71","1":"05eb240489011b80f65f","2":"b098681f31406db4aaff","3":"01a6bdd87037a67e9013","4":"3cdf49b47f6db2a8e7f3","5":"004063d42d69505fa948","6":"da1e09bef1b9ec1c30d8","7":"7598509a86abf33165eb","8":"46e1dbf89f7be7f9883c","9":"b0c84086ae1ec97c7518","10":"8ed4412ccc4da101abf4","12":"a3d9f6a9f8185d2b6c5f","14":"2ec6f53829d0eb167ebd","15":"32a0cb4dfc0aba8701ba","16":"1e8c90899b06a13bf4c2","17":"7ce77225ecfe5276e421","18":"bfcd1ea57d5d1479bbe8","19":"df56a6c341df971bc808","20":"a214ed633ff954eb3b50","21":"54b1dc52ead8f479ced9","22":"7a70d41b0bffea723810","23":"d6803cd8b48ef38c32ee","24":"bfe8a5adcc5a6fa48b63","25":"4f1c3cd15a1c73f7339c","26":"2cd781210789d55c5677","27":"41dc79f24e5d2548dee6","28":"0669702dec4e2c219be8","29":"18ce40ae019f05a792a6","30":"b3b46c3a082085c434b3","31":"d1b091fddf140fb5ed41","32":"d8f7056b617e89bc0d7b","33":"cedf59cbacf17561fb61","34":"07980cfa3c31fbd63d91","35":"15c0177227e39d2df5fb","36":"c1f9c37d0c984880e7b6","37":"2ca61387adc71ab2a60e","38":"ef3c7b9e1a591951f0b7","39":"d0d4cd5d3fe20a0b42d3","40":"f6f8b1d7be2fd09d479a","41":"99d308d6fe7236fb0c1f","42":"0d10183f9d630e67b426","43":"940bcbad78fd3b68f593","44":"070a7c5e5be4680d968e","45":"994bca0ce5b90fb12d6b","46":"2fda95457c0a7f8954ed","47":"c61c51db1f3c6bda1bb5","48":"96f2ef859bcb843f114a","49":"f6954c407a4e81e13015","50":"99c929cde629a258ca1f","51":"64ec459d5ae954105c78","52":"5e4ad75d18ddeb107199","53":"60b3698e8d0383ce4fd1","54":"124ed748dde642b49a9c","55":"d57754bb6f5cb1d301bb","56":"cc8ee3afc0d2d77611bc","57":"a76cfb4858824dbadf15","58":"445ab36bac6aa9694e5e","59":"f75037b23a4cb053daaa","60":"a940b57fdada0b3b80d1","61":"73dce97c23b8fbb9efa9","62":"32bb054ca9c5959f88c4"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"438238ce735cb86152492855ee3f160ec420997f","2":"34692a9b614e75619b8e184bddb0b3c2ff3513c3","3":"ee949b2b07ca884f0b22538b9f496ad97bbc8c20","4":"56044c602de0e43a2cd4294be05cb9c30a8532fc","5":"73f3f4c2","6":"a089a8acdb26dadc66876f444bca0ebddd606de4","7":"component---src-pages-home-index-js","8":"d487e1d7","9":"f39abd17","10":"component---ambassador-docs-docs-1-12-js-doc-page-js","12":"61af03ec","14":"component---ambassador-docs-docs-1-10-js-doc-page-js","15":"component---ambassador-docs-docs-1-11-js-doc-page-js","16":"component---ambassador-docs-docs-1-3-js-doc-page-js","17":"component---ambassador-docs-docs-1-4-js-doc-page-js","18":"component---ambassador-docs-docs-1-5-js-doc-page-js","19":"component---ambassador-docs-docs-1-6-js-doc-page-js","20":"component---ambassador-docs-docs-1-7-js-doc-page-js","21":"component---ambassador-docs-docs-1-8-js-doc-page-js","22":"component---ambassador-docs-docs-1-9-js-doc-page-js","23":"component---ambassador-docs-docs-pre-release-js-doc-page-js","24":"component---src-pages-404-js","25":"component---src-pages-about-us-events-js","26":"component---src-pages-about-us-news-js","27":"component---src-pages-best-practices-index-js","28":"component---src-pages-cloud-acceleration-pyramid-index-js","29":"component---src-pages-codenewbie-index-js","30":"component---src-pages-codenewbiecloud-index-js","31":"component---src-pages-contact-index-js","32":"component---src-pages-demo-index-js","33":"component---src-pages-devdiscuss-index-js","34":"component---src-pages-docs-index-js","35":"component---src-pages-edge-stack-editions-index-js","36":"component---src-pages-edge-stack-faq-js","37":"component---src-pages-editions-index-js","38":"component---src-pages-eula-js","39":"component---src-pages-learn-kubernetes-glossary-index-js","40":"component---src-pages-partners-index-js","41":"component---src-pages-preview-events-js","42":"component---src-pages-preview-index-js","43":"component---src-pages-preview-news-js","44":"component---src-pages-preview-partners-js","45":"component---src-pages-products-argo-index-js","46":"component---src-pages-products-index-js","47":"component---src-pages-resources-index-js","48":"component---src-pages-terms-of-service-js","49":"component---src-pages-use-case-collaborative-development-index-js","50":"component---src-pages-use-case-local-kubernetes-development-index-js","51":"component---src-pages-use-cases-kubernetes-api-gateway-index-js","52":"component---src-templates-features-page-js","53":"component---src-templates-glossary-page-js","54":"component---src-templates-home-home-template-js","55":"component---src-templates-internal-news-page-js","56":"component---src-templates-old-resource-page-js","57":"component---src-templates-person-page-js","58":"component---src-templates-regular-page-js","59":"component---src-templates-resource-page-js","60":"component---src-templates-tutorial-page-js","61":"component---src-templates-webinar-page-js","62":"component---src-templates-white-paper-page-js"}[chunkId]||chunkId) + "." + {"0":"8a33f946ee1bf0c24a95","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
